<script>
import { computed, defineComponent, onMounted, ref, watch } from 'vue';

import { ContourLabel } from '../store/contours/contour-definitions';
import { useViewportStateStore } from '../store/contours/viewport-state-store';
import VtkTwoView from './VtkTwoView.vue';

export default defineComponent({
  name: 'ViewerComponent',

  components: {
    VtkTwoView,
  },

  props: {
    width: { type: Number },
    height: { type: Number },
  },

  setup() {
    const viewportStateStore = useViewportStateStore();
    const activeView = ref(null);

    const setActiveView = (viewId) => {
      activeView.value = viewId;
    };

    const activeViewImageId = computed(() => {
      if (!activeView.value) return null;
      return viewportStateStore.getSelectedImageUID(activeView.value);
    });

    const updateContourTools = () => {
      const viewerContourLabels = [
        ContourLabel.GeneralPolygon,
        ContourLabel.GeneralLine,
        ContourLabel.AnnotationArrow,
        ContourLabel.AnnotationText,
      ];
      viewportStateStore.setAllowedContourLabels('ViewerComponentTopLeft', viewerContourLabels);
      viewportStateStore.setAllowedContourLabels('ViewerComponentTopRight', viewerContourLabels);
      viewportStateStore.setAllowedContourLabels('ViewerComponentBottomLeft', viewerContourLabels);
      viewportStateStore.setAllowedContourLabels('ViewerComponentBottomRight', viewerContourLabels);
    };

    onMounted(() => {
      updateContourTools();
    });

    watch(activeViewImageId, (newImageId) => {
      const allViews = [
        'ViewerComponentTopLeft',
        'ViewerComponentTopRight',
        'ViewerComponentBottomLeft',
        'ViewerComponentBottomRight',
      ];

      allViews.forEach((viewId) => {
        if (viewId !== activeView.value) {
          viewportStateStore.addReferenceImage(viewId, newImageId, true);
        }
        else {
          viewportStateStore.clearReferenceImageUids(viewId);
        }
      });
    });

    return {
      activeView,
      setActiveView,
      activeViewImageId,
    };
  },
});
</script>

<template>
  <div
    class="vtk-two-view-container"
    :style="{ width: `${width}px`, height: `${height}px` }"
  >
    <div class="vtk-two-view-row">
      <VtkTwoView
        id="ViewerComponentTopLeft"
        class="vtk-two-view"
        title="I"
        :class="{ 'active-view': activeView === 'ViewerComponentTopLeft' }"
        style="background: #333333"
        @click="setActiveView('ViewerComponentTopLeft')"
      />
      <VtkTwoView
        id="ViewerComponentTopRight"
        class="vtk-two-view"
        title="II"
        :class="{ 'active-view': activeView === 'ViewerComponentTopRight' }"
        style="background: #333333"
        @click="setActiveView('ViewerComponentTopRight')"
      />
    </div>
    <div class="vtk-two-view-row">
      <VtkTwoView
        id="ViewerComponentBottomLeft"
        class="vtk-two-view"
        title="III"
        :class="{ 'active-view': activeView === 'ViewerComponentBottomLeft' }"
        style="background: #333333"
        @click="setActiveView('ViewerComponentBottomLeft')"
      />
      <VtkTwoView
        id="ViewerComponentBottomRight"
        class="vtk-two-view"
        title="IV"
        :class="{ 'active-view': activeView === 'ViewerComponentBottomRight' }"
        style="background: #333333"
        @click="setActiveView('ViewerComponentBottomRight')"
      />
    </div>
  </div>
</template>

<style scoped>
.vtk-two-view-container {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #333333;
}

.vtk-two-view-row {
  display: flex;
  flex: 1;
  width: 100%;
  height: 50%;
  min-height: 0;
  background: #333333;
}

.vtk-two-view {
  flex: 1;
  width: 50%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  background: white;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.active-view {
  border-color: #0000bd;
}
</style>
